import React from 'react';

export default function ScreenShotIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 25C20.3 25 19 23.7 19 22C19 20.3 20.3 19 22 19C23.7 19 25 20.3 25 22C25 23.7 23.7 25 22 25ZM11 25H8.5C5.5 25 3 22.5 3 19.5V17C3 16.4 3.4 16 4 16C4.6 16 5 16.4 5 17V19.5C5 21.4 6.6 23 8.5 23H11C11.6 23 12 23.4 12 24C12 24.6 11.6 25 11 25ZM14 18C11.8 18 10 16.2 10 14C10 11.8 11.8 10 14 10C16.2 10 18 11.8 18 14C18 16.2 16.2 18 14 18ZM24 12C23.4 12 23 11.6 23 11V8.5C23 6.6 21.4 5 19.5 5H8.5C6.6 5 5 6.6 5 8.5V11C5 11.6 4.6 12 4 12C3.4 12 3 11.6 3 11V8.5C3 5.5 5.5 3 8.5 3H19.5C22.5 3 25 5.5 25 8.5V11C25 11.6 24.6 12 24 12Z"
        fill="#1E2E5E"
      />
    </svg>
  );
}
